import Grid from '@mui/material/Grid';
import Title from "../Shared/Title";
import Icon from '../Shared/Icon';
import Match from "../Match/Match";
import Pod from '../Shared/Pod';
import SchoolIcon from '@mui/icons-material/School';
import BadgeIcon from '@mui/icons-material/Badge';
import KeyIcon from '@mui/icons-material/Key';
import ListIcon from '@mui/icons-material/List';

const Row = props => {
    return (
        <Grid container className="ContainerRow">
            <Grid item xs={4}>
                <Title
                    row
                    href={`/systems/${props.item.Id}`}
                    systems={props.systems}
                    label={props.item.Name}
                />
            </Grid>
            <Grid item xs={2}>
                {props.item.Description && <Match type="descriptions" matches={[props.item.Description]} />}
            </Grid>
            <Grid item xs={2}>
                <Pod icon={<SchoolIcon />}>
                    <Icon system={props.item.AuthStudents} />
                    <KeyIcon />
                    &nbsp;
                    <Icon system={props.item.RosterStudents} />
                    <ListIcon />
                </Pod>
            </Grid>
            <Grid item xs={2}>
                <Pod icon={<BadgeIcon />}>
                    <Icon system={props.item.AuthStaff} />
                    <KeyIcon />
                    &nbsp;
                    <Icon system={props.item.RosterStaff} />
                    <ListIcon />
                </Pod>
            </Grid>
        </Grid>
    )
}

export default Row